// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbody {\n  min-width: 100% !important;\n}\n.width_1000 {\n  width: 1000px !important;\n}\n.width_600 {\n  width: 600px !important;\n}\n.width_700 {\n  width: 700px !important;\n}\n", ""]);
// Exports
module.exports = exports;
